<template>
    <div class="orderHeader">
        <div class="header-left" @click="back">
           <span class="iconfont iconzuojiantou"></span>
        </div>
        <div class="header-center">
           <p>{{title}}</p>
        </div>
        <div class="header-right" @click="toHome">
           <span class="iconfont iconshouye"></span>
        </div>
    </div>
</template>

<script>
export default {
   props:['title'],
   name:'Header',
   methods: {
      back () {
          this.$router.back()
      },
      toHome () {
         this.$router.push('/')
      }
   }
    
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
 .orderHeader
   position: fixed
   z-index: 90
   left: 0
   right: 0
   top: 0
   display: flex
   justify-content: space-between
   width: 100%
   height: 40px
   align-items: center
   background-color: white
   font-weight: bold
   .header-left
      margin-left: 8px
      height: 100%
      width: 40px
      display: flex
      align-items: center
   .header-right
      margin-right: 8px
      width: 40px
      height: 100%
      display: flex
      align-items: center
      justify-content: flex-end
      .iconshouye
        font-size: 20px
</style>



// WEBPACK FOOTER //
// src/components/OrderHeader/OrderHeader.vue